import {
    fontSize,
    typography,
} from '@sensei/pi-component/dist/theme/typography';
import { ThemeOptions } from '@mui/material';

export const MuiButton = (theme: ThemeOptions) => {
    let rootStyles = {};
    if (theme.components?.MuiButton?.styleOverrides?.root) {
        rootStyles = theme.components?.MuiButton?.styleOverrides?.root;
    }
    return {
        styleOverrides: {
            root: {
                ...rootStyles,
                '&[direction="backward"]': {
                    paddingLeft: 0,
                    paddingRight: 0,
                    '& .MuiButton-endIcon': {
                        margin: 0,
                    },
                },
            },
            containedSizeLarge: {
                borderRadius: `calc(${typography.pxToRem(fontSize)} + 8px)`,
            },
            outlinedSizeLarge: {
                borderRadius: `calc(${typography.pxToRem(fontSize)} + 8px)`,
            },
        },
    };
};
